import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

export default function EmergencyFiberPage() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const services = [
    {
      title: 'Acil Fiber Arıza Müdahalesi',
      desc: 'Kesilen veya hasar gören fiber kabloların 7/24 acil onarımı',
      icon: 'ri-alarm-warning-line',
      response: '2 Saat',
    },
    {
      title: 'Mobil Ekip Hizmeti',
      desc: 'Tam donanımlı mobil ekip ile her lokasyonda müdahale',
      icon: 'ri-truck-line',
      response: 'Anında',
    },
    {
      title: 'Geçici Fiber Bağlantı',
      desc: 'Kalıcı onarım öncesi geçici fiber bağlantı kurulumu',
      icon: 'ri-links-line',
      response: '1 Saat',
    },
    {
      title: 'OTDR Test ve Rapor',
      desc: 'Onarım sonrası OTDR test ve detaylı rapor hazırlama',
      icon: 'ri-file-list-3-line',
      response: 'Anında',
    },
  ];

  const coverage = [
    { city: 'İstanbul Avrupa', time: '1-2 Saat' },
    { city: 'İstanbul Anadolu', time: '1-2 Saat' },
    { city: 'Kocaeli', time: '1-2 Saat' },
    { city: 'Gebze', time: '1 Saat' },
    { city: 'Tuzla', time: '1 Saat' },
    { city: 'Dilovası', time: '1 Saat' },
    { city: 'Çayırova', time: '1 Saat' },
    { city: 'Bursa', time: '2-3 Saat' },
    { city: 'Sakarya', time: '2-3 Saat' },
    { city: 'Yalova', time: '2-3 Saat' },
    { city: 'Tekirdağ', time: '2-3 Saat' },
    { city: 'Çorlu', time: '2-3 Saat' },
  ];

  const equipment = [
    {
      name: 'Fusion Splicer',
      desc: 'Fujikura ve Sumitomo marka kaynak cihazları',
      icon: 'ri-flashlight-line',
    },
    {
      name: 'OTDR Cihazı',
      desc: 'Fluke ve EXFO marka test cihazları',
      icon: 'ri-line-chart-line',
    },
    {
      name: 'Güç Ölçer',
      desc: 'Optik güç ölçer ve ışık kaynağı',
      icon: 'ri-dashboard-line',
    },
    {
      name: 'Fiber Cleaver',
      desc: 'Yüksek hassasiyetli kesme aletleri',
      icon: 'ri-scissors-line',
    },
    {
      name: 'VFL',
      desc: 'Visual Fault Locator - Görsel arıza bulucu',
      icon: 'ri-eye-line',
    },
    {
      name: 'Yedek Malzeme',
      desc: 'Fiber kablo, konnektör, pigtail stoku',
      icon: 'ri-box-3-line',
    },
  ];

  const faqData = [
    {
      question: 'Acil fiber arıza durumunda ne yapmalıyım?',
      answer: '7/24 acil servis hattımızı (+90 553 716 55 61) arayın veya WhatsApp üzerinden bize ulaşın. Arıza lokasyonu, fiber tipi ve arıza durumu hakkında bilgi verin. Ekibimiz en kısa sürede size geri dönüş yapacak ve en yakın ekibi olay yerine yönlendirecektir. Ortalama yanıt süremiz 2 saattir.',
    },
    {
      question: 'Acil servis ücreti nasıl hesaplanır?',
      answer: 'Acil servis ücreti, arıza lokasyonu, fiber sayısı, arıza tipi ve müdahale saatine göre belirlenir. Mesai saatleri içinde standart ücretlendirme, mesai dışı ve hafta sonları %50 ek ücret uygulanır. Detaylı fiyat teklifi, arıza bilgileri alındıktan sonra verilir. Acil durumlarda önce müdahale edilir, ücretlendirme sonra yapılır.',
    },
    {
      question: 'Geçici fiber bağlantı nedir?',
      answer: 'Geçici fiber bağlantı, kalıcı onarım için gerekli malzeme veya zaman yoksa, mekanik ek veya hızlı konnektör ile yapılan geçici çözümdür. Bu sayede fiber hat kısa sürede devreye alınır, iş sürekliliği sağlanır. Daha sonra uygun zamanda kalıcı fusion splicing ile onarım yapılır.',
    },
    {
      question: 'Hangi bölgelerde acil servis veriyorsunuz?',
      answer: 'İstanbul Avrupa ve Anadolu yakası, Kocaeli, Gebze, Tuzla, Dilovası, Çayırova, Bursa, Sakarya, Yalova, Tekirdağ ve Çorlu bölgelerinde 7/24 acil fiber servis hizmeti veriyoruz. Ortalama yanıt süremiz İstanbul ve yakın bölgelerde 1-2 saat, diğer bölgelerde 2-3 saattir.',
    },
    {
      question: 'Acil serviste hangi ekipmanlar kullanılır?',
      answer: 'Mobil ekiplerimiz tam donanımlıdır. Fusion splicer, OTDR, güç ölçer, fiber cleaver, VFL ve tüm yedek malzemeler (fiber kablo, konnektör, pigtail) araçlarımızda bulunur. Bu sayede olay yerinde tüm işlemler yapılabilir, ek malzeme veya ekipman için bekleme olmaz.',
    },
  ];

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  return (
    <>
      <title>7/24 Acil Fiber Servis İstanbul | Acil Fiber Arıza Müdahalesi</title>
      <meta name="description" content="İstanbul ve çevre illerde 7/24 acil fiber optik arıza müdahalei. Kesilen fiber kablo tamiri, geçici bağlantı, mobil ekip hizmeti. Ortalama 2 saat yanıt süresi." />
      <meta name="keywords" content="acil fiber servis, 7/24 fiber tamiri, acil fiber arıza, fiber kablo kesintisi, acil fiber müdahale, İstanbul acil fiber, mobil fiber ekip" />
      <link rel="canonical" href="https://fiberek.com/fiber-hizmetleri/acil-servis" />
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>

      <div className="min-h-screen bg-dark-950">
        <Navbar />

        {/* Hero Section */}
        <section className="relative pt-32 pb-20 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-red-900/20 via-dark-950 to-orange-900/20"></div>
          <div className="absolute inset-0">
            <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-red-500 rounded-full animate-ping"></div>
            <div className="absolute top-1/3 right-1/3 w-2 h-2 bg-orange-500 rounded-full animate-ping" style={{ animationDelay: '1s' }}></div>
            <div className="absolute bottom-1/4 left-1/2 w-2 h-2 bg-red-500 rounded-full animate-ping" style={{ animationDelay: '2s' }}></div>
          </div>
          
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center max-w-4xl mx-auto">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
              >
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-500/20 border border-red-500/50 rounded-full mb-6 animate-pulse">
                  <i className="ri-alarm-warning-line text-red-400"></i>
                  <span className="text-red-400 text-sm font-bold">7/24 ACİL SERVİS</span>
                </div>

                <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
                  Acil Fiber Optik
                  <span className="block text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-orange-400">
                    Arıza Müdahalesi
                  </span>
                </h1>

                <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                  Kesilen veya hasar gören fiber kabloların 7/24 acil onarımı. Mobil ekip ile her lokasyonda hızlı müdahale. 
                  İstanbul ve çevre illerde ortalama 2 saat yanıt süresi garantisi.
                </p>

                <div className="flex flex-wrap items-center justify-center gap-4 mb-12">
                  <a
                    href="tel:+905537165561"
                    className="inline-flex items-center gap-2 px-10 py-5 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-all duration-300 font-bold text-xl shadow-lg shadow-red-500/50 whitespace-nowrap cursor-pointer animate-pulse"
                  >
                    <i className="ri-phone-line text-2xl"></i>
                    ACİL ARAMA: +90 553 716 55 61
                  </a>
                  <a
                    href="https://wa.me/908505551234"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-10 py-5 bg-emerald-500 text-white rounded-lg hover:bg-emerald-600 transition-all duration-300 font-bold text-xl shadow-lg shadow-emerald-500/50 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-whatsapp-line text-2xl"></i>
                    WhatsApp
                  </a>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl mx-auto">
                  <div className="bg-dark-900/50 backdrop-blur-sm rounded-xl p-4 border border-red-500/30">
                    <div className="text-3xl font-bold text-red-400 mb-1">7/24</div>
                    <div className="text-sm text-gray-400">Kesintisiz Hizmet</div>
                  </div>
                  <div className="bg-dark-900/50 backdrop-blur-sm rounded-xl p-4 border border-orange-500/30">
                    <div className="text-3xl font-bold text-orange-400 mb-1">2 Saat</div>
                    <div className="text-sm text-gray-400">Ortalama Yanıt</div>
                  </div>
                  <div className="bg-dark-900/50 backdrop-blur-sm rounded-xl p-4 border border-red-500/30">
                    <div className="text-3xl font-bold text-red-400 mb-1">12+</div>
                    <div className="text-sm text-gray-400">Hizmet Bölgesi</div>
                  </div>
                  <div className="bg-dark-900/50 backdrop-blur-sm rounded-xl p-4 border border-orange-500/30">
                    <div className="text-3xl font-bold text-orange-400 mb-1">100%</div>
                    <div className="text-sm text-gray-400">Mobil Donanım</div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Services */}
        <section className="py-20 bg-dark-950">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-white mb-4">Acil Servis Hizmetlerimiz</h2>
              <p className="text-gray-400">7/24 kesintisiz fiber optik acil müdahale hizmetleri</p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {services.map((service, index) => (
                <motion.div
                  key={service.title}
                  ref={ref}
                  initial={{ opacity: 0, y: 20 }}
                  animate={inView ? { opacity: 1, y: 0 } : {}}
                  transition={{ delay: index * 0.1 }}
                  className="bg-gradient-to-br from-dark-900 to-dark-800 rounded-xl p-6 border border-white/10 hover:border-red-500/50 transition-all duration-300"
                >
                  <div className="w-14 h-14 bg-red-500/20 rounded-lg flex items-center justify-center mb-4">
                    <i className={`${service.icon} text-2xl text-red-400`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">{service.title}</h3>
                  <p className="text-gray-400 text-sm mb-4">{service.desc}</p>
                  <div className="inline-flex items-center gap-2 px-3 py-1 bg-red-500/20 rounded-full">
                    <i className="ri-time-line text-red-400 text-xs"></i>
                    <span className="text-red-400 text-xs font-semibold">{service.response}</span>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Coverage */}
        <section className="py-20 bg-gradient-to-br from-red-900/10 via-dark-950 to-orange-900/10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-white mb-4">Acil Servis Kapsama Alanı</h2>
              <p className="text-gray-400">İstanbul ve çevre illerde hızlı müdahale garantisi</p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {coverage.map((area, index) => (
                <motion.div
                  key={area.city}
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={inView ? { opacity: 1, scale: 1 } : {}}
                  transition={{ delay: index * 0.05 }}
                  className="bg-dark-900 rounded-xl p-6 border border-white/10 hover:border-red-500/50 transition-all duration-300"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <i className="ri-map-pin-line text-2xl text-red-400"></i>
                      <h3 className="text-lg font-bold text-white">{area.city}</h3>
                    </div>
                    <div className="text-right">
                      <div className="text-sm text-gray-400">Yanıt Süresi</div>
                      <div className="text-lg font-bold text-red-400">{area.time}</div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Equipment */}
        <section className="py-20 bg-dark-950">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-white mb-4">Mobil Ekip Donanımı</h2>
              <p className="text-gray-400">Tam donanımlı mobil ekip ile her lokasyonda müdahale</p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {equipment.map((item, index) => (
                <motion.div
                  key={item.name}
                  initial={{ opacity: 0, y: 20 }}
                  animate={inView ? { opacity: 1, y: 0 } : {}}
                  transition={{ delay: index * 0.1 }}
                  className="bg-gradient-to-br from-dark-900 to-dark-800 rounded-xl p-6 border border-white/10"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-red-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-xl text-red-400`}></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-white mb-2">{item.name}</h3>
                      <p className="text-gray-400 text-sm">{item.desc}</p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Process */}
        <section className="py-20 bg-gradient-to-br from-red-900/10 via-dark-950 to-orange-900/10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-white mb-4">
                Acil Müdahale Süreci
              </h2>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                className="bg-gradient-to-br from-dark-900 to-dark-800 rounded-xl p-8 border border-white/10 relative"
              >
                <div className="absolute -top-4 -left-4 w-12 h-12 bg-gradient-to-br from-red-500 to-orange-500 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg shadow-red-500/30">
                  1
                </div>
                <h3 className="text-xl font-bold text-white mb-3 mt-4">Arıza Bildirimi</h3>
                <p className="text-gray-400 text-sm">
                  7/24 acil hat üzerinden arıza bildirimi alınır. Lokasyon ve arıza detayları kaydedilir.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ delay: 0.1 }}
                className="bg-gradient-to-br from-dark-900 to-dark-800 rounded-xl p-8 border border-white/10 relative"
              >
                <div className="absolute -top-4 -left-4 w-12 h-12 bg-gradient-to-br from-red-500 to-orange-500 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg shadow-red-500/30">
                  2
                </div>
                <h3 className="text-xl font-bold text-white mb-3 mt-4">Ekip Yönlendirme</h3>
                <p className="text-gray-400 text-sm">
                  En yakın mobil ekip anında olay yerine yönlendirilir. Müşteriye bilgi verilir.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ delay: 0.2 }}
                className="bg-gradient-to-br from-dark-900 to-dark-800 rounded-xl p-8 border border-white/10 relative"
              >
                <div className="absolute -top-4 -left-4 w-12 h-12 bg-gradient-to-br from-red-500 to-orange-500 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg shadow-red-500/30">
                  3
                </div>
                <h3 className="text-xl font-bold text-white mb-3 mt-4">Olay Yeri Müdahale</h3>
                <p className="text-gray-400 text-sm">
                  Ekip olay yerine ulaşır, arıza tespiti yapar ve onarım işlemine başlar.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ delay: 0.3 }}
                className="bg-gradient-to-br from-dark-900 to-dark-800 rounded-xl p-8 border border-white/10 relative"
              >
                <div className="absolute -top-4 -left-4 w-12 h-12 bg-gradient-to-br from-red-500 to-orange-500 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg shadow-red-500/30">
                  4
                </div>
                <h3 className="text-xl font-bold text-white mb-3 mt-4">Test ve Teslimat</h3>
                <p className="text-gray-400 text-sm">
                  Onarım tamamlanır, OTDR testi yapılır, rapor hazırlanır ve sistem devreye alınır.
                </p>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Content Section */}
        <section className="py-20 bg-dark-950">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-16">
              <div>
                <h2 className="text-4xl font-bold text-white mb-6">
                  Neden 7/24 Acil Servis?
                </h2>
                <div className="prose prose-invert max-w-none">
                  <p className="text-gray-300 leading-relaxed mb-6">
                    Fiber optik altyapı, günümüzde işletmelerin kritik iletişim omurgasıdır. 
                    Bir fiber arızası, internet kesintisi, telefon sistemlerinin çökmesi, güvenlik kameralarının devre dışı kalması 
                    ve üretim hatlarının durması gibi ciddi sonuçlara yol açabilir.
                  </p>

                  <div className="bg-dark-900 rounded-xl p-6 border border-white/10 mb-6">
                    <h3 className="text-xl font-bold text-white mb-4">Fiber Arıza Nedenleri</h3>
                    <ul className="space-y-3 text-gray-300">
                      <li className="flex items-start gap-2">
                        <i className="ri-error-warning-line text-red-400 mt-1"></i>
                        <span><strong className="text-white">Kazı ve İnşaat:</strong> Yol çalışması, kazı veya inşaat sırasında fiber kablonun kesilmesi</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-error-warning-line text-red-400 mt-1"></i>
                        <span><strong className="text-white">Mekanik Hasar:</strong> Ezilme, çekme veya darbe sonucu fiber kırılması</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-error-warning-line text-red-400 mt-1"></i>
                        <span><strong className="text-white">Doğal Afet:</strong> Deprem, sel veya fırtına nedeniyle altyapı hasarı</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-error-warning-line text-red-400 mt-1"></i>
                        <span><strong className="text-white">Konnektör Sorunu:</strong> Kirli veya hasarlı konnektör nedeniyle sinyal kaybı</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-error-warning-line text-red-400 mt-1"></i>
                        <span><strong className="text-white">Ek Noktası Arızası:</strong> Fusion splicing noktasında kayıp artışı veya kopma</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-dark-900 rounded-xl p-6 border border-white/10">
                    <h3 className="text-xl font-bold text-white mb-4">Acil Servis Avantajları</h3>
                    <ul className="space-y-3 text-gray-300">
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-red-400 mt-1"></i>
                        <span><strong className="text-white">Hızlı Müdahale:</strong> Ortalama 2 saat içinde olay yerine ulaşım</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-red-400 mt-1"></i>
                        <span><strong className="text-white">Tam Donanım:</strong> Mobil ekipte tüm ekipman ve yedek malzeme mevcut</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-red-400 mt-1"></i>
                        <span><strong className="text-white">Deneyimli Ekip:</strong> 10+ yıl deneyimli sertifikalı fiber optik uzmanları</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-red-400 mt-1"></i>
                        <span><strong className="text-white">Geçici Çözüm:</strong> Kalıcı onarım öncesi geçici bağlantı ile hizmet sürekliliği</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-red-400 mt-1"></i>
                        <span><strong className="text-white">Test ve Rapor:</strong> OTDR testi ve detaylı onarım raporu</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-4xl font-bold text-white mb-6">
                  Acil Servis Çalışma Saatleri
                </h2>
                <div className="space-y-6">
                  <div className="bg-gradient-to-br from-red-900/20 to-orange-900/20 rounded-xl p-8 border border-red-500/30">
                    <div className="flex items-center gap-4 mb-6">
                      <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center">
                        <i className="ri-24-hours-line text-3xl text-red-400"></i>
                      </div>
                      <div>
                        <h3 className="text-2xl font-bold text-white">7/24 Kesintisiz Hizmet</h3>
                        <p className="text-gray-400">Hafta içi, hafta sonu ve resmi tatillerde</p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="bg-dark-900/50 rounded-lg p-4">
                        <div className="text-sm text-gray-400 mb-1">Hafta İçi</div>
                        <div className="text-lg font-bold text-white">00:00 - 24:00</div>
                      </div>
                      <div className="bg-dark-900/50 rounded-lg p-4">
                        <div className="text-sm text-gray-400 mb-1">Hafta Sonu</div>
                        <div className="text-lg font-bold text-white">00:00 - 24:00</div>
                      </div>
                      <div className="bg-dark-900/50 rounded-lg p-4">
                        <div className="text-sm text-gray-400 mb-1">Resmi Tatil</div>
                        <div className="text-lg font-bold text-white">00:00 - 24:00</div>
                      </div>
                      <div className="bg-dark-900/50 rounded-lg p-4">
                        <div className="text-sm text-gray-400 mb-1">Gece Saatleri</div>
                        <div className="text-lg font-bold text-white">Aktif</div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-dark-900 rounded-xl p-6 border border-white/10">
                    <h3 className="text-xl font-bold text-white mb-4">İletişim Kanalları</h3>
                    <div className="space-y-4">
                      <a
                        href="tel:+905537165561"
                        className="flex items-center gap-4 p-4 bg-dark-800 rounded-lg hover:bg-dark-700 transition-all cursor-pointer"
                      >
                        <div className="w-12 h-12 bg-red-500/20 rounded-lg flex items-center justify-center">
                          <i className="ri-phone-line text-xl text-red-400"></i>
                        </div>
                        <div>
                          <div className="text-sm text-gray-400">Acil Arama Hattı</div>
                          <div className="text-lg font-bold text-white">+90 553 716 55 61</div>
                        </div>
                      </a>

                      <a
                        href="https://wa.me/908505551234"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-4 p-4 bg-dark-800 rounded-lg hover:bg-dark-700 transition-all cursor-pointer"
                      >
                        <div className="w-12 h-12 bg-emerald-500/20 rounded-lg flex items-center justify-center">
                          <i className="ri-whatsapp-line text-xl text-emerald-400"></i>
                        </div>
                        <div>
                          <div className="text-sm text-gray-400">WhatsApp Destek</div>
                          <div className="text-lg font-bold text-white">7/24 Aktif</div>
                        </div>
                      </a>

                      <div className="flex items-center gap-4 p-4 bg-dark-800 rounded-lg">
                        <div className="w-12 h-12 bg-blue-500/20 rounded-lg flex items-center justify-center">
                          <i className="ri-mail-line text-xl text-blue-400"></i>
                        </div>
                        <div>
                          <div className="text-sm text-gray-400">E-posta</div>
                          <div className="text-lg font-bold text-white">acil@fiber.com</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-dark-900 rounded-xl p-6 border border-white/10">
                    <h3 className="text-xl font-bold text-white mb-4">Arıza Bildirirken Belirtin</h3>
                    <ul className="space-y-2 text-gray-300 text-sm">
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-line text-red-400 mt-1"></i>
                        <span>Arıza lokasyonu (adres, bina, kat)</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-line text-red-400 mt-1"></i>
                        <span>Arıza tipi (kesinti, yavaşlık, sinyal kaybı)</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-line text-red-400 mt-1"></i>
                        <span>Fiber tipi ve sayısı (biliniyorsa)</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-line text-red-400 mt-1"></i>
                        <span>İletişim bilgileriniz</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-line text-red-400 mt-1"></i>
                        <span>Aciliyet durumu</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-20 bg-gradient-to-br from-red-900/10 via-dark-950 to-orange-900/10">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-white mb-4">
                Sıkça Sorulan Sorular
              </h2>
            </div>

            <div className="space-y-4">
              {faqData.map((faq, index) => (
                <motion.details
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={inView ? { opacity: 1, y: 0 } : {}}
                  transition={{ delay: index * 0.1 }}
                  className="group bg-dark-900 rounded-xl border border-white/10 overflow-hidden"
                >
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none">
                    <h3 className="text-lg font-semibold text-white pr-4">{faq.question}</h3>
                    <i className="ri-arrow-down-s-line text-2xl text-red-400 group-open:rotate-180 transition-transform flex-shrink-0"></i>
                  </summary>
                  <div className="px-6 pb-6">
                    <p className="text-gray-400 leading-relaxed">{faq.answer}</p>
                  </div>
                </motion.details>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-20 bg-dark-950">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="bg-gradient-to-br from-red-900/20 to-orange-900/20 rounded-2xl p-12 border border-red-500/30">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-500/20 border border-red-500/50 rounded-full mb-6 animate-pulse">
                <i className="ri-alarm-warning-line text-red-400"></i>
                <span className="text-red-400 text-sm font-bold">ACİL DURUM</span>
              </div>
              
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                Fiber Arızanız mı Var?
              </h2>
              <p className="text-xl text-gray-300 mb-8">
                Hemen arayın, ekibimiz 2 saat içinde olay yerinde olsun
              </p>
              <div className="flex flex-wrap items-center justify-center gap-4">
                <a
                  href="tel:+905537165561"
                  className="inline-flex items-center gap-2 px-10 py-5 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-all duration-300 font-bold text-xl shadow-lg shadow-red-500/50 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line text-2xl"></i>
                  +90 553 716 55 61
                </a>
                <a
                  href="https://wa.me/908505551234"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-10 py-5 bg-emerald-500 text-white rounded-lg hover:bg-emerald-600 transition-all duration-300 font-bold text-xl shadow-lg shadow-emerald-500/30 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-2xl"></i>
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </section>

        <Footer />
        <FloatingButtons />
      </div>
    </>
  );
}